import { Config } from '@stencil/core';
import { config as baseConfig } from './stencil.config';

// Used for local development
export const config: Config = {
  ...baseConfig,
  sourceMap: false,
  devServer: {
    openBrowser: false,
  },
  outputTargets: [],
};
